module.exports = __webpack_public_path__ + "static/media/SPITITSWAP-FTM-SPIRIT.c514d003.png";